import { AuditableResponse } from "../common/AuditableResponse"
import { Cartridge } from "@/@types/responses/cartridge/Cartridge"

export class CaliberDetails extends AuditableResponse {
  id: number
  boreDiameter: number
  name: string
  cartridges: Cartridge[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, boreDiameter?: number, name?: string, cartridgesJson?: any, createdByUser?: any, createdDate?: string, lastModifiedByUser?: any, lastModifiedDate?: string) {
    super(createdByUser, createdDate, lastModifiedByUser, lastModifiedDate)
    this.id = id
    this.boreDiameter = boreDiameter ?? 0
    this.name = name ?? ''
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.cartridges = cartridgesJson ? cartridgesJson.map((c: any) => new Cartridge(c.id, c.diameterMinimum, c.name)) : []
  }
}
